import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-annotation', 'open', 'Open annotation');
Labels.set('ui-annotation', 'close', 'Close annotation');
